export default __webpack_public_path__ + "static/media/check.912a8ea0.svg";